module.exports = __webpack_public_path__ + "img/Armarria2.727e1922.png";